import DisplayText from '@sdk/components/ui/DisplayText';
import gettext from '@sdk/lang/gettext';
import HorizontalSeparator from '@sdk/components/ui/HorizontalSeparator';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import CheckmarkIcon from '@web/assets/svg/UI/checkmark-blue-small.svg';

import { Container, ListContainer, KeyFeaturesContainer } from './subscriptionFeatureList.styles';

type Props = {
  title: string;
  subtitle: string;
  featureList?: string[];
  footerText: string;
};

export const SubscriptionFeatureList = ({ title, subtitle, featureList, footerText }: Props) => {
  return (
    <Container>
      <DisplayText fontSize={18} bold lineHeight={24}>
        {title}
      </DisplayText>
      <DisplayText fontSize={14}>{subtitle}</DisplayText>

      <ListContainer>
        <HorizontalSeparator />
        <DisplayText bold fontSize={12}>
          {gettext('Key features')}
        </DisplayText>
        <KeyFeaturesContainer>
          {featureList.map((feature) => (
            <li key={feature}>
              <CheckmarkIcon />
              <DisplayText fontSize={12} lineHeight={20} themeColor={ThemeColorType.gray}>
                {feature}
              </DisplayText>
            </li>
          ))}
        </KeyFeaturesContainer>
        <DisplayText fontSize={12} lineHeight={20} themeColor={ThemeColorType.iconGray}>
          {footerText}
        </DisplayText>
      </ListContainer>
    </Container>
  );
};
